<template>
  <div class="room-info">
    <div class="name">{{ roomInfo.name }}</div>
    <div class="id">ID:{{ roomUidName }}</div>
  </div>
</template>
<script>
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';

export default {
  name: 'RoomInfo',
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {
    roomInfo() {
      return VoiceRoomProvider.roomInfo || {};
    },
    roomUidName() {
      return this.$route.params.roomUid;
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.room-info {
  width: 100%;
  height: 51px;
  background: rgba(36, 42, 56, 0.46);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.info {
  color: white;
}
.name {
  font-size: 18px;
  color: rgba(255, 255, 255, 1);
}
.id {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}
</style>
